import React, { useEffect } from 'react'

function SgSelection({
  paths,
  scope,
  selectionRect,
  setSelectionRect,
  selectionRectPathKeys,
  setSelectionRectPathKeys,
  isResizeActive,
}) {
  // paths의 변화에 따라 유효하지 않은 path의 key를 selectionRectPathKey에서 제거 (동시편집)
  useEffect(() => {
    if (selectionRectPathKeys.length === 0) return

    const validSelectionRectPathKeys = selectionRectPathKeys.filter((key) => !!paths[key])

    if (validSelectionRectPathKeys.length !== selectionRectPathKeys.length) {
      setSelectionRectPathKeys(validSelectionRectPathKeys)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paths])

  // < selectionRect 렌더링 effect >
  useEffect(() => {
    if (selectionRectPathKeys.length) {
      const sgSelection = {
        top: Infinity,
        left: Infinity,
        right: -Infinity,
        bottom: -Infinity,
      }
      for (let key of selectionRectPathKeys) {
        if (!paths[key]) continue

        sgSelection.top = Math.min(paths[key].y + paths[key].minY, sgSelection.top)
        sgSelection.left = Math.min(paths[key].x + paths[key].minX, sgSelection.left)
        sgSelection.right = Math.max(paths[key].x + paths[key].maxX, sgSelection.right)
        sgSelection.bottom = Math.max(paths[key].y + paths[key].maxY, sgSelection.bottom)
      }

      setSelectionRect({
        top: sgSelection.top,
        left: sgSelection.left,
        width: sgSelection.right - sgSelection.left,
        height: sgSelection.bottom - sgSelection.top,
      })
    } else {
      setSelectionRect({ top: 0, left: 0, width: 0, height: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paths, selectionRectPathKeys])

  return (
    <div
      id='sg-selection'
      className={`${
        selectionRectPathKeys.length && !isResizeActive ? 'sg-absolute' : 'sg-hidden'
      } sg-border sg-border-blue-500 sg-z-[9999]`}
      style={{
        top: `${selectionRect.top}px`,
        left: `${selectionRect.left}px`,
        width: `${selectionRect.width}px`,
        height: `${selectionRect.height}px`,
        boxSizing: 'border-box',
      }}
    >
      {/* Border Components */}

      <div
        id='selection-border-top'
        style={{
          position: 'absolute',
          top: '-5px',
          left: '0',
          width: '100%',
          height: '10px',
          backgroundColor: 'transparent',
          cursor: 'ns-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-border-right'
        style={{
          position: 'absolute',
          top: '0',
          right: '-5px',
          width: '10px',
          height: '100%',
          backgroundColor: 'transparent',
          cursor: 'ew-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-border-bottom'
        style={{
          position: 'absolute',
          bottom: '-5px',
          left: '0',
          width: '100%',
          height: '10px',
          backgroundColor: 'transparent',
          cursor: 'ns-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-border-left'
        style={{
          position: 'absolute',
          top: '0',
          left: '-5px',
          width: '10px',
          height: '100%',
          backgroundColor: 'transparent',
          cursor: 'ew-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>

      {/* Corner Components */}
      <div
        id='selection-corner-top-left'
        style={{
          position: 'absolute',
          top: '-5px',
          left: '-5px',
          width: '10px',
          height: '10px',
          border: '1px solid blue',
          backgroundColor: 'white',
          cursor: 'nwse-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-corner-top-right'
        style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          width: '10px',
          height: '10px',
          border: '1px solid blue',
          backgroundColor: 'white',
          cursor: 'nesw-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-corner-bottom-right'
        style={{
          position: 'absolute',
          bottom: '-5px',
          right: '-5px',
          width: '10px',
          height: '10px',
          border: '1px solid blue',
          backgroundColor: 'white',
          cursor: 'nwse-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
      <div
        id='selection-corner-bottom-left'
        style={{
          position: 'absolute',
          bottom: '-5px',
          left: '-5px',
          width: '10px',
          height: '10px',
          border: '1px solid blue',
          backgroundColor: 'white',
          cursor: 'nesw-resize',
          transform: `scale(${1 / scope})`,
        }}
      ></div>
    </div>
  )
}

export default SgSelection
